<div class="header__view">
    <a class="header__brand" routerLink="/home" aria-label="Zur Startseite">
        <img class="header__brand__mark"
             src="assets/img/logos/rettensteiner-mark-trimmed.png"
             alt="Metzgerei Rettensteiner-Scharfetter">
        <span class="header__brand__text">
            <span class="header__brand__name">Rettensteiner Scharfetter</span>
            <span class="header__brand__sub">Metzgerei &amp; Marktstubn</span>
        </span>
    </a>

    <app-navigation></app-navigation>

    <div class="header__actions">
        <div class="header__social">
            <a href="https://www.facebook.com/profile.php?id=100063801932792"
               target="_blank"
               rel="noopener"
               aria-label="Facebook">
                <img class="social-icon" src="assets/icon/facebook.svg" alt="">
            </a>
            <a href="https://www.instagram.com/marktstubn/"
               target="_blank"
               rel="noopener"
               aria-label="Instagram">
                <img class="social-icon" src="assets/icon/instagram.svg" alt="">
            </a>
        </div>
        <a class="header__cta"
           href="https://bestellen.marktstubn.com/"
           target="_blank"
           rel="noopener">Vorbestellen</a>
    </div>
</div>
